import R from 'ramda'
import { isSendDmFormAction } from './send-dm'

const SEND_DARK_REPLY_ACTION_TYPE = 'SEND_DARK_REPLY'
const SEND_DARK_REPLY_DISPLAY_TYPE = 'Send reply'

const isSendDarkReplyFormAction = R.both(
  R.propEq('type', SEND_DARK_REPLY_DISPLAY_TYPE),
  R.complement(isSendDmFormAction)
)

const convertSendDarkReplyFormActionToWidgetAction = R.applySpec({
  type: R.always(SEND_DARK_REPLY_ACTION_TYPE),
  attachmentUrl: R.prop('attachmentUrl'),
  cardUri: R.prop('cardUri'),
  media: R.prop('media'),
  message: R.prop('message'),
  quickReply: R.prop('quickReply'),
  ctas: R.prop('ctas')
})

export {
  isSendDarkReplyFormAction,
  convertSendDarkReplyFormActionToWidgetAction
}



// WEBPACK FOOTER //
// ./src/pages/widgets/mapping/actions/twitter/form-to-widget/send-dark-reply.js